import React, { FC } from "react";
import "../Styles/Contact.css";

const SastecLogo = require("../StaticAssets/Logo sastec group 2.png");
const Contact: FC = () => {
  return (
    <>
      <div className="contact_container container">
        <div>
          <img src={SastecLogo} className="contact_logo" alt="" />
        </div>
        <div className="contat_infos">
          <h1 className="contact_infos_title">Contact</h1>
          <p className="contact_adress">
            Adresse : 23 Rue Aristide Briand - 94340 Joinville Le Pont
          </p>
          <p className="contact_email">E-mail : contact@sastec-group.com </p>
          <p className="contact_tel">Tel : +33 618419027</p>
        </div>
      </div>
    </>
  );
};

export default Contact;
